import { render, staticRenderFns } from "./afterOrderDetail.vue?vue&type=template&id=26f9850a&scoped=true"
import script from "./afterOrderDetail.vue?vue&type=script&lang=js"
export * from "./afterOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./afterOrderDetail.vue?vue&type=style&index=0&id=26f9850a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f9850a",
  null
  
)

export default component.exports